import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import { Box, Button, Stack, Typography } from "@mui/material";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useAudio } from "../contexts/AudioContexts";
import { usePush } from "../contexts/PushContexts";

export default function CancelledJobDrawer() {
  const { formatMessage } = useIntl();
  const { lastNotification, setLastNotification } = usePush();
  const { playNotificationLoop, stopNotificationLoop } = useAudio();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerToggle = useCallback(
    (isOpen: boolean) => {
      const themeColorMeta = document.querySelector<HTMLMetaElement>(
        'meta[name="theme-color"]',
      );

      setDrawerOpen(isOpen);

      if (isOpen) {
        themeColorMeta?.setAttribute("content", "#7e7e7e");
        playNotificationLoop("notification-sound.mp3");
      } else {
        setLastNotification({ type: null, unit: undefined });
        themeColorMeta?.setAttribute("content", "#fcfcfc");
        stopNotificationLoop();
      }
    },
    [playNotificationLoop, setLastNotification, stopNotificationLoop],
  );

  useEffect(() => {
    if (lastNotification?.type === "dispatch-job.unit-cancelled") {
      handleDrawerToggle(true);
    }
  }, [handleDrawerToggle, lastNotification?.type]);

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={drawerOpen}
      onClose={() => handleDrawerToggle(false)}
      onOpen={() => {}}
      disableSwipeToOpen
      slotProps={{
        backdrop: { sx: { backgroundColor: "rgba(0, 0, 0, 0.5)" } },
        paper: {
          sx: {
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            maxHeight: "65vh",
            background: "linear-gradient(145deg, #ffffff 0%, #f5f5f5 100%)",
            px: 3,
            pt: 2,
            pb: 3,
          },
        },
      }}
    >
      <Box
        sx={{
          width: 48,
          height: 4,
          bgcolor: "grey.300",
          borderRadius: 2,
          mx: "auto",
          mb: 3,
        }}
      />
      <Stack alignItems="center" spacing={6} mt={2} mb={1}>
        <Box
          sx={{
            width: 60,
            height: 60,
            mb: 3,
            background: "linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)",
            borderRadius: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PriorityHighIcon
            sx={{ fontSize: 40, color: (theme) => theme.palette.warning.dark }}
          />
        </Box>
        <Typography variant="raptor-main-p">
          {formatMessage(
            {
              defaultMessage: "{unit} mission has been cancelled",
            },
            {
              unit: lastNotification.unit,
            },
          )}
        </Typography>
        <Button
          variant="contained"
          fullWidth
          onClick={() => handleDrawerToggle(false)}
        >
          <Typography variant="raptor-button-text">
            {formatMessage({ defaultMessage: "Acknowledge" })}
          </Typography>
        </Button>
      </Stack>
    </SwipeableDrawer>
  );
}
